import store from "@/store";

const routes = [{
    path: "/accounting/accounting-user/:id",
    name: "acctusers",
    component: () => import('@/views/main/modules/Accounting/AccountingUser/AccountingUserComponent.vue'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Accounting User',
    }
}]

export default routes;
